// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1LQJY","detailsBorder":"styles_detailsBorder__1Q5Vk"};